import ROUTES from '../routes';
import ExternalAccounts from '../hoc/external';
import ExternalAccountForm from '../hoc/external/form';
import ExternalAccountsList from '../hoc/external/list';
import LinkedClients from '../hoc/external/linked-clients-list';
import CreateLinkedClientForm from '../hoc/external/linked-clients-form';

const ExternalRoutes = {
  path: ROUTES.EXTERNAL_ACCOUNTS,
  element: <ExternalAccounts />,
  children: [
    {
      path: ROUTES.EXTERNAL_ACCOUNTS_LIST,
      element: <ExternalAccountsList />,
      children: [
        {
          path: ROUTES.EXTERNAL_ACCOUNTS_LIST_CREATE,
          element: <ExternalAccountForm />,
        },
        {
          path: ROUTES.EXTERNAL_ACCOUNT,
          element: <ExternalAccountForm />,
        },
      ],
    },
    {
      path: ROUTES.EXTERNAL_ACCOUNTS_LINKED_CLIENTS,
      element: <LinkedClients />,
      children: [
        {
          path: ROUTES.EXTERNAL_ACCOUNTS_LINKED_CLIENTS_CREATE,
          element: <CreateLinkedClientForm />,
        },
      ],
    },
  ],
};

export default ExternalRoutes;
